<script setup>
import {reactive, onMounted, computed, watch, nextTick} from 'vue';
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";

const props = defineProps({
  contextIdA: String,
  contextSchemaA: String
});

const data = reactive({
      dataLoading: true,
      valid: true,
      dialog: false,
      dialogDelete: false,
      isEditing: false,
      search: '',
      openClientForm: false,
      loaded: true,
      editedIndex: -1,
      contacts: [],
      headers: [
        {
          title: 'Name',
          align: 'start',
          key: 'insuredname',
        },
        { title: 'Role', key: 'role', sortable: false },
        { title: 'Phone', key: 'homephone', sortable: false },
        { title: 'Email', key: 'email', sortable: false },
        { title: 'Actions', key: 'actions', sortable: false }
      ],
      editedItem: {
        insuredname: '',
        role: '',
        homephone: '',
        email: '',
        id: ''
      },
      defaultItem: {
        insuredname: '',
        role: '',
        homephone: '',
        email: '',
        id: ''
      },
      tempItem: {
        insuredname: null,
        role: null,
        homephone: null,
        email: null,
      },
    })

const formTitle = computed(()=>{
  return data.editedIndex === -1 ? 'New Item' : 'Edit Item'
});

watch(data.dialog,(val) => {
  val || close()
});

watch(data.dialogDelete,(val) => {
  val || closeDelete()
});

const getData = () => {
  data.dataLoading = true

  ApiWrapper.post('clients','get-client-contacts-client-page', { clientId: props.contextIdA })
      .then((response) => {
        if(response.clientContacts){
          data.contacts = response.clientContacts
        }
      })
      .catch((e)=>{
        ToastUtil.error(e);
      })
      .finally(()=>{
        data.dataLoading = false
      })
}

const editItem = (item) => {
  data.tempItem.insuredname = item.insuredname
  data.tempItem.role = item.role
  data.tempItem.homephone = item.homephone
  data.tempItem.email = item.email
  data.isEditing = true
  data.editedItem = JSON.parse(JSON.stringify(item))
  data.dialog = true
}
// Delete functionality is almost setup (needs finishing) if needed for future use, but delete icon is disabled until further notice
// deleteItem (item) {
//   data.editedIndex = data.certificationTypes.indexOf(item)
//   data.editedItem = Object.assign({}, item)
//   data.dialogDelete = true
// },

const deleteItemConfirm = () => {
  data.contacts.splice(data.editedIndex, 1)
  closeDelete()
}

// Delete functionality is almost setup (needs finishing) if needed for future use, but delete icon is disabled until further notice
// deleteItem(item) {
//   const deleteMessage = confirm('Are you sure you want to delete this item?');
//   if (deleteMessage == true) {
//     data.loading = true;
//     let contextId = new URLSearchParams(window.location.search).get(
//       'contextIdA'
//     )
//     ApiWrapper.post('Clients', 'deleteClientContactsClientPage/', { item: item })
//       .then((response) => {
//         data.getData();
//         data.loading = false;
//         ToastUtil.successMessage('Deleted client contact');
//       })
//       .catch((e) => {
//          ToastUtil.error(e);
//        });
//   }
// },

const close = () => {
  data.dialog = false
  data.editedItem.insuredname = data.tempItem.insuredname
  data.editedItem.role = data.tempItem.role
  data.editedItem.homephone = data.tempItem.homephone
  data.editedItem.email = data.tempItem.email
  nextTick(() => {
    data.editedItem = Object.assign({}, data.defaultItem)
    data.editedIndex = -1
    data.isEditing = false;
  })
}

// Delete functionality is almost setup (needs finishing) if needed for future use, but delete icon is disabled until further notice
// closeDelete () {
//   data.dialogDelete = false
//   nextTick(() => {
//     data.editedItem = Object.assign({}, data.defaultItem)
//     data.editedIndex = -1
//   })
// },


const save = async (item) => {
  data.dataLoading = true
  if (data.isEditing) {
    await ApiWrapper.post('clients', 'edit-client-contacts-client-page', {
          clientId: props.contextIdA,
          editedItem: data.editedItem,
        })
        .then((response) => {
          getData();
          data.dataLoading = false;
          ToastUtil.successMsg('Updated client contact');
        })
        .catch((err) => {
          ToastUtil.error(err);
          data.dataLoading = false;
        })
  } else {
    await ApiWrapper.post('clients', 'create-client-contacts-client-page', {
          clientId: props.contextIdA,
          editedItem: data.editedItem,
        })
        .then((response) => {
          getData();
          data.dataLoading = false;
          ToastUtil.successMsg('Created client contact');
        })
        .catch((err) => {
          ToastUtil.error(err);
          data.dataLoading = false;
        })
  }
  close()

}

const closeDelete = () => {
  data.dialogDelete = false
  nextTick(() => {
    data.editedItem = Object.assign({}, data.defaultItem)
    data.editedIndex = -1
  })
}

onMounted(()=>{
  getData()
})


</script>

<template>
  <v-container>
      <v-card class="mx-auto">
        <v-data-table
            :headers="data.headers"
            :items="data.contacts"
            :search="data.search"
            mobile-breakpoint="400"
            :loading="data.dataLoading"
            loading-text="Loading... Please wait"
        >
          <template v-slot:top>
            <v-toolbar
                flat
                color="white"
            >
              <v-toolbar-title>Client Contacts Manager</v-toolbar-title>
              <v-divider
                  class="mx-4"
                  inset
                  vertical
              ></v-divider>
              <v-spacer></v-spacer>
              <v-dialog
                  v-model="data.dialog"
                  max-width="500px"
              >
                <template v-slot:activator="{ on, props }">
                  <v-btn
                      color="primary"
                      class="mb-2"
                      variant="elevated"
                      v-bind="props"
                      v-on="on"
                      v-if="Permissions.checkPermissions(['clients.create-contacts'])"
                      size="small"
                  >
                    Add
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="py-0">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text class="pb-0">
                    <v-container>
                      <v-row>
                        <v-col
                            cols="6"
                            sm="6"
                            md="4"
                            class="py-0"
                        >
                          <v-text-field
                              v-model="data.editedItem.insuredname"
                              label="Contact Name"
                          ></v-text-field>
                        </v-col>
                        <v-col
                            cols="6"
                            sm="6"
                            md="4"
                            class="py-0"
                        >
                          <v-text-field
                              v-model="data.editedItem.role"
                              label="Role"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                            cols="6"
                            sm="6"
                            md="4"
                            class="py-0"
                        >
                          <v-text-field
                              v-model="data.editedItem.homephone"
                              label="Phone"
                          ></v-text-field>
                        </v-col>
                        <v-col
                            cols="6"
                            sm="6"
                            md="4"
                            class="py-0"
                        >
                          <v-text-field
                              v-model="data.editedItem.email"
                              label="Email"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue darken-1"
                        variant="text"
                        @click="close(item)"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                        color="blue darken-1"
                        variant="text"
                        @click="save"
                        :disabled="data.editedItem.insuredname === '' || data.editedItem.insuredname === null"
                    >
                      Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="data.dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="headline">Are you sure you want to delete this item?</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" variant="text" @click="closeDelete">Cancel</v-btn>
                    <v-btn color="blue darken-1" variant="text" @click="deleteItemConfirm">OK</v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
            <v-row>
              <v-col
                  cols="12"
                  sm="6"
              >
                <v-text-field
                    v-model="data.search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                    class="mx-4"
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-icon
                size="small"
                class="mr-2"
                v-if="Permissions.checkPermissions(['clients.update-contacts'])"
                @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <!-- Delete functionality is almost setup (needs finishing) if needed for future use, but delete icon is disabled until further notice -->
            <!-- <v-icon
              size="small"
              @click="deleteItem(item)"
            >
              mdi-delete
            </v-icon> -->
          </template>
        </v-data-table>
      </v-card>
  </v-container>
</template>

<style scoped>
  .container {
    padding: 5px;
  }

  [v-cloak] {
    display: none;
  }
</style>